
import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCalendarAlt, faUtensils, faCartShopping} from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/images/logo_istanbul.png';
import { UserContext } from '../contexts/UserContext';

const Entete = () => {
    const navigate = useNavigate();
    const { user, setUser } = useContext(UserContext); // Accéder au rôle utilisateur
    const { gerant, setGerant } = useContext(UserContext);
    const handleLogout = () => {
      // Supprimer les données utilisateur du localStorage ou du contexte
      localStorage.removeItem('user');
      setUser(null);
      localStorage.removeItem('gerant');
      setGerant(null);
      navigate('/login'); // Rediriger vers la page de connexion
    };
  
    return (
    <div className="content mrg-pg">
        <div className="row">
            <div className="col-md-3">
                <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/boutique">
                    <img className="logo mb-3" src={logo} alt="restaurant istanbul"/>
                </Link>
            </div>
            <div className="col-md-9 d-flex justify-content-end align-items-start">
                 <Link className="btn-size btn-rs hover-mr mr-3" to="/panier">
                <FontAwesomeIcon className="mr-2"  icon={faCartShopping} />
                    <span>  Voir mon panier</span>
                </Link>
                <Link className="btn-size btn-bg hover-mr mr-3" to="https://commande.restaurant-narbonne-istanbul.com/reservation">
                <FontAwesomeIcon className="mr-2" icon={faCalendarAlt} />
                    <span>  Réserver table</span>
                </Link>
                <Link className="btn-size btn-orng hover-mr" to="/boutique">
                    <FontAwesomeIcon className="mr-2" icon={faUtensils} />
            
                    <span>  Voir menu</span>
                </Link>
            </div>
        </div>
    </div> 

);
};

export default Entete;